import axios from 'axios';

import AxiosServerInstanceClass from '../utilities/axiosServerInstance';
import { ALLOWED_QUERY_OPERATOR } from '../utilities/constants';
import { API_URL_NEW, SSR_API_URL_NEW } from '../utilities/endpoints';
import { prepareSelectParam, prepareFilterParam } from '../utilities/queryParams';

export default {
    getFeaturedNews: async (token = "", refreshToken = "") => {
        const AxiosInstance = new AxiosServerInstanceClass(token, refreshToken);
        AxiosInstance.req();
        AxiosInstance.res();

        try {
            const fields = prepareSelectParam([
                'id',
                'code',
                'title',
                'body',
                'source',
                'image_data',
                'published_at',
                'news_category_data',
                'industry_data',
            ]);

            const URL = `${SSR_API_URL_NEW}/news?fields=${fields}&filters=is_featured^:1^,is_published^:1&sort=published_at^:desc&limit=6`;
    
            const response = await AxiosInstance.axiosInstance.get(URL);
            
            const data = response.data.data;
            return data;
    
        } catch (error) {
            throw error;
        }
    },

    fetchNewsDetails: async (slug, token = "", refreshToken = "") => {
        const AxiosInstance = new AxiosServerInstanceClass(token, refreshToken);
        AxiosInstance.req();
        AxiosInstance.res();

        // Get the id from the slug string, example: test-news-article-3223
        const id = parseInt(slug.split('-').pop());

        if (!Number.isInteger(id)) {
            return {};
        }

        const arrFields = [
            'id',
            'code',
            'title',
            'body',
            'source',
            'author',
            'image_data',
            'image_credit',
            'news_category_data',
            'industry_data',
            'published_at',
            'created_at',
            'updated_at',
            'is_published',
            'sponsor_name',
            'sponsor_description',
            'sponsor_logo_data',
            'preview_image_data'
        ];
        const fields = prepareSelectParam(arrFields);

        try {
            const response = await AxiosInstance.axiosInstance.get(`${SSR_API_URL_NEW}/news/${id}?fields=${fields}`);
            const data = await response.data.data;
            if (data.id) {
                return data;
            } else {
                throw new Error('invalid news data');
            }
        } catch (error) {
            return 404;
        }
    },

    getRelatedNews: (id) => {
        const URL = `${API_URL_NEW}/news/${id}/related`;
        return new Promise((resolve, reject) => {
            axios
                .get(URL)
                .then(async (res) => {
                    if (res && res.data && res.data.data) {
                        resolve(res.data.data);
                    } else {
                        reject(new Error('getRelatedNews: response had no data'));
                    }
                })
                .catch((err) => reject(err));
        });
    },

    getNewsList: (dirFilters, limit, page) => {
        const fields = prepareSelectParam([
            'id',
            'title',
            'image_data',
            'code',
            'published_at',
            'industry_data',
            'country_data',
            'news_category_data',
            'body',
            'sponsor_name',
            'sponsor_description',
            'sponsor_logo_data'
        ]);
        const filters = prepareFilterParam(dirFilters);

        const URL = `${API_URL_NEW}/news?fields=${fields}&filters=${filters}^,is_published^:1&limit=${limit}&page=${page}&sort=published_at^:desc`;

        return new Promise((resolve, reject) => {
            axios
                .get(URL)
                .then(async (res) => {
                    if (res && res.data && res.data.data) {
                        let count;
                        if (res.data.navigation.total < res.data.navigation.limit) {
                            count = res.data.navigation.total;
                        } else {
                            count = res.data.navigation.limit * res.data.navigation.page;
                        }

                        resolve({
                            data: res.data.data,
                            count,
                            total: res.data.navigation.total,
                        });
                    } else {
                        reject(new Error('getNewsList: response had no data'));
                    }
                })
                .catch((err) => reject(err));
        });
    },

    getNewsUTMLinKByCategory: (categoryId = "", token = "", refreshToken = "") => {
        const AxiosInstance = new AxiosServerInstanceClass(token, refreshToken);
        AxiosInstance.req();
        AxiosInstance.res();

        const fields = prepareSelectParam(['utm_link']);
        const filters = prepareFilterParam([
            { key: 'category_id', value: [categoryId], op: ALLOWED_QUERY_OPERATOR.equal }
        ]);

        const URL = `${SSR_API_URL_NEW}/news-utm?fields=${fields}&filters=${filters}&limit=1`;

        return new Promise((resolve, reject) => {
            AxiosInstance.axiosInstance.get(URL).then(
                response => {
                    resolve(response.data.data);
                })
                .catch((err) => reject(err));
        });
    },

    getMentions: (id) => {
        const fields = prepareSelectParam([
            'id',
            'news_id',
            'entity_data',
            'entity_id'
        ]);

        const URL = `${API_URL_NEW}/news/${id}/news-mention?fields=${fields}`;

        return new Promise((resolve, reject) => {
            axios
                .get(URL)
                .then(async (res) => {
                    if (res && res.data && res.data.data) {
                        resolve(res.data.data);
                    } else {
                        reject(new Error('getMentions: response had no data'));
                    }
                })
                .catch((err) => reject(err));
        });
    },
};
